import {Box, Menu, MenuItem, IconButton, ListItemIcon, ListItemText, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';

import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import CustomPopper from "../../../core/components/common/custom-popper.component";
import { useState } from "react";
import UpdateGateStatusDialog from "../dialogs/update-gate-status-dialog.component";
import DeleteGateDialog from "../dialogs/delete-gate-dialog.component";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import { useNavigate } from "react-router-dom";

const ListGateComponent = (props) => {
    const {headers, data} = props;

    const [currentSelectedGate, setCurrentSelectedGate] = useState(null);
    const [openUpdateGateStatusConfirmDialog, setOpenUpdateGateStatusConfirmDialog] = useState(false)
    const [openDeleteGateConfirmDialog, setOpenDeleteGateConfirmDialog] = useState(false)
    const {hasPermission} = useGuard();

    const theme = useTheme();
    const navigate = useNavigate()

    const handleDeactivate = (gate) => {
        setCurrentSelectedGate(gate)
        setOpenUpdateGateStatusConfirmDialog(true);
    }

    const handleActivate = (gate)=> {
        setCurrentSelectedGate(gate)
        setOpenUpdateGateStatusConfirmDialog(true);
    }

    const handleCloseUpdateGateStatusConfirmDialog = () => {
        setOpenUpdateGateStatusConfirmDialog(false);
    }

    const handleDelete = (gate) => {
        setCurrentSelectedGate(gate)
        setOpenDeleteGateConfirmDialog(true);
    } 

    const handleCloseDeleteGateConfirmDialog = () => {
        setOpenDeleteGateConfirmDialog(false);
    }

    const handleView = (gate) => {
        console.log("gate bbb", gate);
        navigate('/gates/view?id=' + gate.gate_uid)
    }

    const getMenuItems = (gate) => {
        const { VIEW_GATE, CHANGE_STATUS_GATE, DELETE_GATE } = permissions.gate;
        const status = gate.status.toLowerCase();
        const items = [
            {
                id: 'view',
                icon: VisibilityIcon,
                text: 'View Details',
                color: '#0b99da',
                handler: () => handleView(gate),
                requiredPermission: VIEW_GATE,
            },
            {
                id: status === 'active' ? 'deactivate' : 'activate',
                icon: status === 'active' ? DoDisturbIcon : CheckCircleIcon,
                text: status === 'active' ? 'Deactivate' : 'Activate',
                color: status === 'active' ? 'red' : 'green',
                handler: () => (status === 'active' ? handleDeactivate(gate) : handleActivate(gate)),
                requiredPermission: CHANGE_STATUS_GATE,
            },
            {
                id: 'delete',
                icon: DeleteIcon,
                text: 'Delete Gate',
                color: 'red',
                handler: () => handleDelete(gate),
                requiredPermission: DELETE_GATE,
            },
        ];

        return items.filter(item => hasPermission(item.requiredPermission));
    };

    return(
        <>
            <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
                <TableContainer>
                    <Table>
                        <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                            <TableRow>
                                {headers.map((header, index) => (
                                    <TableCell
                                        key={index}
                                        align="start"
                                        sx={{color: theme.typography.secondary, fontWeight: 600}}
                                    >
                                        {header}
                                    </TableCell>
                                ))}                   
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data?.length > 0 ? (
                                data?.map((gate) => {
                                    const menu_items = getMenuItems(gate)
                                    return(
                                        <>
                                            <TableRow key={gate.id}>
                                            <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                                {gate.gatename}
                                            </TableCell>

                                            <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                                {gate.type}
                                            </TableCell>

                                            <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                                {gate.location}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                <CustomChipComponent category="portStatus"
                                                    label={(gate.status === "Active") ? "Active" 
                                                        : 
                                                            (gate.status === "Deactivated") ? "Deactivated"
                                                        :
                                                            gate.status
                                                    }
                                                />
                                            </TableCell>

                                            <TableCell align="start">
                                                {
                                                    menu_items.length > 0 &&
                                                    <CustomPopper row={gate} icon={MoreVertIcon} menuItems={menu_items} />
                                                }
                                            </TableCell>
                                        </TableRow>
                                        </>
                                    )
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={headers?.length} align="center">
                                        No gate data available to display
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {openUpdateGateStatusConfirmDialog && 
                    <UpdateGateStatusDialog 
                        open={openUpdateGateStatusConfirmDialog} 
                        close={handleCloseUpdateGateStatusConfirmDialog} 
                        currentSelectedGate={currentSelectedGate}
                    />
                }

                {openDeleteGateConfirmDialog && 
                    <DeleteGateDialog 
                        open={openDeleteGateConfirmDialog} 
                        close={handleCloseDeleteGateConfirmDialog} 
                        currentSelectedGate={currentSelectedGate}
                    />
                }
            </Paper>
        </>
    )
}

export default ListGateComponent